import React from "react";

const SmsProviderList = () => {
  return <div>list</div>;
};

export default SmsProviderList;
